import React from "react";
import { v4 } from "uuid";
import classNames from "classnames";
import "./ReportButton.scss";

export function ReportButton(props) {
  const activeCard = { inleverReportCardActive: props.active };
  const activeDot = { inleverReportDotActive: props.active };

  return (
    <div
      className={classNames("reportButton", activeCard)}
      onClick={props.onClick}
    >
      <div
        className={classNames("reportButton-inleverReportDot", activeDot)}
      ></div>
      <div className="reportButton-text-wrapper">
        <span key={v4()} className="reportButton-text">
          {props.reportText}
        </span>
        {props.active && (
          <span key={v4()} className="reportButton-description">
            {props.reportDescription}
          </span>
        )}
      </div>
    </div>
  );
}
